import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { VendorProductsService } from '../../../../services/vendorproducts/vendorproducts.service';
import { VendorProductsWebhookDetailDialogComponent } from './details/vendor-products-webhook-detail-dialog.component';

@Component({
    selector: 'app-vendor-products-webhooks',
    templateUrl: './vendor-products-webhooks.component.html',
    styleUrls: ['./vendor-products-webhooks.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VendorProductsWebhooksComponent implements OnInit, OnDestroy {
  public items: any[] = [];
  public searchValue = '';
  public page = 0;
  public limit = 25;
  public endOfList = false;
  public loading = false;
  private readonly searchDebounceMs = 300;
  private readonly searchValueChanges = new Subject<string>();
  private readonly searchSubscription: Subscription;

  constructor(
    private vendorProductsService: VendorProductsService,
    private dialog: MatDialog,
  ) {
    this.searchSubscription = this.searchValueChanges
      .pipe(
        debounceTime(this.searchDebounceMs),
        distinctUntilChanged(),
      )
      .subscribe(() => this.loadItems(true));
  }

  ngOnInit(): void {
    this.loadItems(true);
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  async loadItems(clear = false): Promise<void> {
    if (clear) {
      this.page = 0;
      this.endOfList = false;
      this.items = [];
    }
    if (this.loading || this.endOfList) {
      return;
    }
    this.loading = true;
    try {
      const result = await this.vendorProductsService.getProductWebhookLogs(this.searchValue, this.page, this.limit);
      if (!result || result.length === 0) {
        this.endOfList = true;
      } else {
        this.items = this.items.concat(result);
        this.page += 1;
      }
    } catch (error) {
      console.error('Error loading webhook logs', error);
    } finally {
      this.loading = false;
    }
  }

  queueFilter(value: string): void {
    this.searchValueChanges.next((value || '').toString());
  }

  clearSearch(): void {
    this.searchValue = '';
    this.queueFilter('');
  }

  openDetails(item: any): void {
    this.dialog.open(VendorProductsWebhookDetailDialogComponent, {
      width: '900px',
      maxWidth: '95vw',
      data: { item },
    });
  }

  onScroll(event: any): void {
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    const offsetHeight = event.target.offsetHeight;
    if (scrollTop + offsetHeight >= scrollHeight - 150) {
      this.loadItems();
    }
  }

  getPayload(item: any): string {
    if (!item?.payload) {
      return '';
    }
    const text = JSON.stringify(item.payload);
    return text.length > 250 ? `${text.slice(0, 247)}...` : text;
  }
}
